// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  // 加載列表
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_DiagnosisOpen/Load',
      params,
    });
  },
  // 抓取單筆
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_DiagnosisOpen/Get',
      params,
    });
  },
  // 新增
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_DiagnosisOpen/Add',
      data,
    });
  },
  // 更新
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_DiagnosisOpen/Update',
      data,
    });
  },
  // 刪除
  Delete(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_DiagnosisOpen/Delete',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
};
